import BasePage from "@Scripts/Pages/BasePage";

export default class SearchListPage extends BasePage {
    public static async init() {
        await super.init();

        this.setPagination();
    }

    private static setPagination() {
        document.getElementById("PagingIndexList")?.addEventListener("change", x => {
            window.location.href = "/it/ricerca?search=" + (<any>window).App.bag.search + "&page=" + (<any>document).querySelector("#PagingIndexList").value;
        });
    }
}